import { ArrowRight } from 'lucide-react'
import Link from 'next/link'

import { nextLinkHrefFromPathWithOptionalHash } from '@/_lib/next-link-href'

export enum SERVICE_CARD_THEME {
	BLUE = 'blue',
	PURPLE = 'purple',
	TIRQUOIS = 'tirquoise',
	PREVENTIVE = 'preventive',
	CREDIT = 'credit',
	ANNUAL = 'annual',
	FUCHSIA = 'fuchsia',
	AMBULANCE = 'AMBULANCE'
}

export interface IServiceCardProps {
	header: string
	title: string
	description: string
	buttonText?: string
	link: string
	isFavorite?: boolean
	theme: SERVICE_CARD_THEME
}

const ServicesCard: React.FC<IServiceCardProps> = ({
	header,
	title,
	description,
	buttonText = 'Zistiť viac',
	link,
	isFavorite,
	theme
}) => {
	return (
		<Link
			href={nextLinkHrefFromPathWithOptionalHash(link)}
			className={`item_service_modern item_service_${theme.toLowerCase()} ${
				isFavorite ? 'fav' : ''
			}`}
			prefetch={false}
		>
			<div className='item_service_top'>
				<span>{header}</span>
				{isFavorite && (
					<svg className='sico'>
						<g>
							<use href='/assets/layout/icons.svg#s_fav_p1' />
						</g>
						<g className='anim_rotate'>
							<use href='/assets/layout/icons.svg#s_fav_p2' />
						</g>
					</svg>
				)}
			</div>
			<div>
				<div className='item_service_mid'>
					<h4 className='item_service_title'>{title}</h4>
					<div className='page_content'>{description}</div>
				</div>
				<div className='item_service_bottom'>
					<span className='inline-flex items-center gap-2 text-sm !font-medium'>
						{buttonText}
						<ArrowRight size={16} className='inline-block shrink-0 -mt-px ml-1' />
					</span>
				</div>
			</div>
		</Link>
	)
}

export default ServicesCard
